import type { LucideIcon } from 'lucide-react-native';
import { XStack, type XStackProps } from 'tamagui';

import { RingGlyph } from '@/components/ring-glyph';
import { Text } from '@/components/text';
import { iconSize, iconStroke } from '@/theme/icon';

// Static facts about a thing (category, distance, time): plain 14/400 text with
// a 16px icon and no background, so it can never be mistaken for a filter chip
// (interactive, pill) or a Badge (status, rounded rectangle). `icon="ring"` is
// the distance ring, reserved for distance.
export function Metadata({
  icon: Icon,
  label,
  iconColor,
  ...props
}: { icon?: LucideIcon | 'ring'; label: string; iconColor: string } & XStackProps) {
  return (
    <XStack alignItems="center" gap="$2" {...props}>
      {Icon === 'ring' ? (
        <RingGlyph size={16} />
      ) : (
        Icon && <Icon size={iconSize.chip} strokeWidth={iconStroke} color={iconColor} />
      )}
      <Text color="$colorTertiary" fontSize="$meta" lineHeight="$meta" fontWeight="$regular" textAlign="left">
        {label}
      </Text>
    </XStack>
  );
}
